var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiliateDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 8.33333C7.86087 8.33333 9.16671 7.0275 9.16671 5.41667C9.16671 3.80584 7.86087 2.5 6.25004 2.5C4.63921 2.5 3.33337 3.80584 3.33337 5.41667C3.33337 7.0275 4.63921 8.33333 6.25004 8.33333Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.33333C15.3609 8.33333 16.6667 7.0275 16.6667 5.41667C16.6667 3.80584 15.3609 2.5 13.75 2.5C12.1392 2.5 10.8334 3.80584 10.8334 5.41667C10.8334 7.0275 12.1392 8.33333 13.75 8.33333Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.6667H15.4167C17.025 11.6667 18.3333 12.975 18.3333 14.5833C18.3333 16.1917 17.025 17.5 15.4167 17.5H8.75V11.6667Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.5833C11.6666 16.1917 10.3583 17.5 8.74996 17.5H4.58329C3.78329 17.5 3.04996 17.175 2.52496 16.6417C1.99163 16.1167 1.66663 15.3833 1.66663 14.5833C1.66663 12.975 2.97496 11.6667 4.58329 11.6667H8.74996C9.54996 11.6667 10.2833 11.9917 10.8083 12.525C11.3416 13.05 11.6666 13.7833 11.6666 14.5833Z",
    fill: "url(#paint0_linear_6267_5707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6267_5707",
    x1: 6.66663,
    y1: 11.6667,
    x2: 6.66663,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateDefault);
export default __webpack_public_path__ + "static/media/affiliate-default.ec1f8892a8625b3a9c459541c1bc6228.svg";
export { ForwardRef as ReactComponent };